import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClientPrescriberTask } from '../../../core/models/client-prescriber-task.model';
import { LimitOffsetPaging } from '../../../core/models/paged-results/limit-offset-paging.model';
import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ClientPrescriberTaskVisibilityComponent } from '../client-prescriber-task-visibility/client-prescriber-task-visibility.component';
import { ClientPrescriberTaskStatusComponent } from '../client-prescriber-task-status/client-prescriber-task-status.component';
import { ExpirationDateComponent } from '../../../shared/components/expiration-date/expiration-date.component';
import { PatientNameComponent } from '../../../shared/components/patient-name/patient-name.component';
import { PrescriberNameComponent } from '../../../shared/components/prescriber-name/prescriber-name.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { PrescriptionNameComponent } from '../../../shared/components/prescription-name/prescription-name.component';
import { ClaimSourcePipe } from '../../../shared/pipes/claim-source.pipe';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
  selector: 'app-client-prescriber-task-list',
  templateUrl: './client-prescriber-task-list.component.html',
  styleUrls: ['./client-prescriber-task-list.component.scss'],
  imports: [PaginationHeaderComponent,
    RouterLink,
    ClientPrescriberTaskVisibilityComponent,
    ClientPrescriberTaskStatusComponent,
    ExpirationDateComponent,
    PatientNameComponent,
    PrescriberNameComponent,
    NgbTooltip,
    PaginationComponent,
    PrescriptionNameComponent,
    CurrencyPipe,
    DatePipe,
    ClaimSourcePipe,
    BlankValueDashPipe]
})
export class ClientPrescriberTaskListComponent {
  @Input() tasks: ClientPrescriberTask[];
  @Input() paging: LimitOffsetPaging;

  @Output() public pageChange = new EventEmitter<number>();
  @Output() public pageSizeChange = new EventEmitter<number>();

  constructor() {}

  onPageChange(page) {
    this.pageChange.emit(page);
  }

  onPageSizeChange(size) {
    this.pageSizeChange.emit(size);
  }
}
